const messages = {
  en: {
    statics: {
      load_more: 'more',
      home: 'home',
      main: 'main',
      loading: 'loading...',
      contact: 'contact',
      my_mall: 'my mall',
      more: 'more',
      recover_password: 'recover password',
      recover: 'recover',
      share: 'share',
      share_on_facebook: 'share on Facebook',
      share_on_twitter: 'share on Twitter',
      share_on_linkedin: 'share on LinkedIn',
      username_placeholder: 'Enter email address',
      password_placeholder: 'Enter password',
      email_validation: 'Need valid email',
      subscribed_to_newsletter: 'Subscribed to newsletter',
      email_validation_message: 'Please fill in valid email',
      subscribed: 'subscribed',
      stores: 'store',
      events: 'events',
      promotion: 'promotion',
      newCollection: 'new collection',
      newCollections: 'new collections',
      newcollections: 'new collections',
      forgot_password: 'Forgot password?',
      brand: 'brand',
      tags: 'tags',
      socials: 'socials',
      social: 'social media',
      login: 'login',
      registration: 'registration',
      next: 'next',
      subscribe: 'subscribe',
      unsubscribe: 'unsubscribe',
      first_name_placeholder: 'First Name',
      last_name_placeholder: 'Last Name',
      email_placeholder: 'Email',
      mobile_placeholder: 'Mobile',
      birth_date_placeholder: 'Birth Date',
      gender_placeholder: 'Gender',
      country_placeholder: 'Country',
      city_placeholder: 'City',
      reg_password_placeholder: 'Password',
      repeat_password_placeholder: 'Repeat Password',
      additionalServices: 'additional services',
      activities: 'activities',
      notifications: 'notifications',
      subscribe_list: 'subscribed list',
      bookmarks: 'bookmarks',
      entities: 'shops',
      settings: 'settings',
      log_out: 'log out',
      promotions: 'promotions',
      remember_me: 'Remember me',
      not_registered_q: 'not registered?',
      sign_up: 'sign up',
      register: 'register',
      please_enter_to_search: 'PRESS ENTER TO SEARCH',
      store_mobile_search: 'Search for shop or brand',
      gel: 'ლ',
      name: 'name',
      copyLink: 'Copy link',
      email: 'email',
      company: 'company',
      send: 'send',
      telephone: 'telephone',
      your_message: 'your message',
      contact_form_title: 'message box',
      contact_form_description: 'Please complete the form below and click the “send” button to leave your message with us.',
      contact_form_subscribe_text: 'Please subscribe me to Tbilisi Mall newsletter mailing list',
      filter: 'filter',
      our_team: 'our team',
      marketing: 'marketing',
      leasing: 'leasing',
      AboutCompany: 'About Company',
      Contact: 'contact',
      HowToGet: 'how to get',
      featured_search: 'featured search',
      magazine: 'magazine',
      tbilisi_mall_magazine: 'Tbilisi Mall Magazine',
      gift_card: 'gift card',
      bookmark_deleted_successfully: 'Bookmark removed successfully',
      mallTaxi: 'mall taxi',
      password_successfully_recovered: 'password have been set',
      mall_map: 'mall map',
      tbilisi_mall_taxi: 'tbilisi mall taxi',
      about_mall: 'about mall',
      about_us: 'about us',
      download: 'download',
      open: 'open',
      type_here: 'Type here',
      updated_successfully: 'successfully updated',
      guest_service: 'guest service',
      news: 'news',
      viewAll: 'View All',
      information: 'information',
      joinNow: 'JOIN NOW',
      password_updated: 'password updated',
      error: 'error',
      sent: 'sent',
      no_bookmarks: 'You haven\'t bookmarked anything',
      no_subscriptions: 'You haven\'t subscribed anything',
      no_notifications: 'You don\'t have any notifications',
      subscribed_successfully: 'subscribed',
      unsubscribed_successfully: 'unsubscribed',
      bookmarked_successfully: 'You have successfully bookmarked item',
      working_hours: 'working hours',
      working_hours_content: 'Every Day from 10:00 to 22:00',
      address: 'address',
      newPassword: 'new password',
      full_page: 'Full page',
      added_new: 'added new',
      repeatNewPassword: 'confirm new password',
      changePassword: 'change password',
      change: 'change',
      days_ago: 'days ago',
      hours_ago: 'hours ago',
      minutes_ago: 'minutes ago',
      seconds_ago: 'seconds ago',
      save: 'save',
      address_content: '16 km Agmashenebeli Alley, <br> 0131 Tbilisi, Georgia',
      subscribe_list_stores: 'subscribed list',
      see_the_list_below: 'See the list of shops below:',
      subscribeText: 'Sign up for our newsletter to receive special offers, event invitations, and more.',
      enter_your_email: 'Enter your email address'
    }
  },
  ka: {
    statics: {
      load_more: 'მეტის ჩვენება',
      loading: 'იტვირთება...',
      home: 'მთავარი',
      all: 'ყველა',
      entities: 'მაღაზიები',
      offers: 'შეთავაზებები',
      main: 'მთავარი',
      sent: 'გაიგზავნა',
      contact: 'კონტაქტი',
      AboutCompany: 'კომპანიის შესახებ',
      Contact: 'კონტაქტი',
      HowToGet: 'როგორ მივიდეთ',
      my_mall: 'ჩემი მოლი',
      added_new: 'დაამატა ახალი',
      subscribed: 'გამოწერილი',
      recover_password: 'აღადგინე პაროლი',
      recover: 'აღდგენა',
      username_placeholder: 'შეიყვანეთ ელ-ფოსტა',
      password_placeholder: 'შეიყვანეთ პაროლი',
      share: 'გააზიარე',
      error: 'შეცდომა',
      share_on_facebook: 'გააზიარე Facebook-ზე',
      share_on_twitter: 'გააზიარე Twitter-ზე',
      share_on_linkedin: 'გააზიარე LinkedIn-ზე',
      stores: 'მაღაზიები',
      events: 'ღონისძიებები',
      newCollection: 'ახალი კოლექცია',
      newCollections: 'ახალი კოლექციები',
      newcollections: 'ახალი კოლექციები',
      days_ago: 'დღის წინ',
      hours_ago: 'საათის წინ',
      minutes_ago: 'წუთის წინ',
      seconds_ago: 'წამის წინ',
      next: 'შემდეგი',
      type_here: 'ჩაწერეთ საძიებო სიტყვა',
      information: 'ინფორმაცია',
      featured_search: 'რჩეული ძებნა',
      updated_successfully: 'წარმატებით განახლდა',
      password_successfully_recovered: 'პაროლი წარმატებით შეიცვალა',
      subscribed_to_newsletter: 'თქვენ წარმატებით გამოიწერეთ ჩვენი ვებ-გვერდი',
      first_name_placeholder: 'სახელი',
      last_name_placeholder: 'გვარი',
      email_placeholder: 'ელ-ფოსტა',
      email_validation: 'ელ-ფოსტის ფორმატი არასწორია',
      email_validation_message: 'გთხოვთ შეიყვანოთ სწორი ელ-ფოსტის ფორმატი',
      mobile_placeholder: 'მობილურის ნომერი',
      birth_date_placeholder: 'დაბადების თარიღი',
      gender_placeholder: 'სქესი',
      country_placeholder: 'ქვეყანა',
      city_placeholder: 'ქალაქი',
      password_updated: 'შეცვლილია',
      reg_password_placeholder: 'პაროლი',
      repeat_password_placeholder: 'გაიმეორეთ პაროლი',
      forgot_password: 'დაგავიწყდათ პაროლი?',
      name: 'სახელი',
      email: 'ელ-ფოსტა',
      company: 'კომპანია',
      send: 'გაგზავნა',
      telephone: 'ტელეფონი',
      your_message: 'თქვენი შეტყობინება',
      contact_form_subscribe_text: 'მინდა გამოვიწერო სიახლეები თბილისი მოლისგან',
      contact_form_title: 'კონტაქტის ფორმა',
      contact_form_description: 'შეავსეთ ქვემოთ მოცემული ფორმა და დააჭირეთ ღილაკს "გაგზავნა".',
      more: 'მეტი',
      news: 'ახალი ამბები',
      brand: 'ბრენდი',
      login: 'ავტორიზაცია',
      copyLink: 'Copy link',
      filter: 'ფილტრი',
      changed: 'შეიცვალა',
      registration: 'რეგისტრაცია',
      tags: 'თეგები',
      socials: 'ბმულები',
      social: 'სოციალური ქსელი',
      subscribe: 'გამოწერა',
      unsubscribe: 'გაუქმება',
      viewAll: 'ყველას ნახვა',
      additionalServices: 'დამატებითი სერვისები',
      activities: 'აქტივობები',
      notifications: 'შეტყობინებები',
      subscribe_list: 'გამოწერილები',
      bookmarks: 'შენახულები',
      settings: 'პარამეტრები',
      log_out: 'გამოსვლა',
      promotion: 'შეთავაზება',
      remember_me: 'დამიმახსოვრე',
      not_registered_q: 'არ ხართ დარეგისტრირებული?',
      sign_up: 'sign up',
      register: 'რეგისტრაცია',
      please_enter_to_search: 'PRESS ENTER TO SEARCH',
      store_mobile_search: 'მოძებნე მაღაზია ან ბრენდი',
      gel: 'ლ',
      our_team: 'ჩვენი გუნდი',
      bookmark_deleted_successfully: 'სიახლე წარმატებით წაიშალა',
      marketing: 'მარკეტინგი',
      DefaultStatic: 'კომპანიის შესახებ',
      leasing: 'ლიზინგი',
      Career: 'კარიერა',
      magazine: 'ჟურნალი',
      tbilisi_mall_magazine: 'თბილისი მოლის ჟურნალი',
      gift_card: 'სასაჩუქრე ბარათი',
      mallTaxi: 'მოლის ტაქსი',
      tbilisi_mall_taxi: 'მოლის ტაქსი',
      mall_map: 'მოლის რუქა',
      mallMap: 'მოლის რუქა',
      about_mall: 'მოლის შესახებ',
      guest_service: 'მომსახურებები',
      no_bookmarks: 'თქვენ არ გაქვთ შენახული სიახლეები',
      no_subscriptions: 'თქვენ არ გაქვთ გამოწერილი მაღაზიები',
      no_notifications: 'თქვენ არ გაქვთ შეტყობინებები',
      about_us: 'ჩვენ შესახებ',
      download: 'გადმოწერა',
      open: 'გახსნა',
      promotions: 'შეთავაზებები',
      joinNow: 'შემოგვიერთდი',
      working_hours: 'სამუშაო საათები',
      newPassword: 'ახალი პაროლი',
      repeatNewPassword: 'გაიმეორეთ პაროლი',
      changePassword: 'პაროლის შეცვლა',
      change: 'შეცვლა',
      full_page: 'სრულად ნახვა',
      save: 'შენახვა',
      working_hours_content: 'ყოველ დღე 10:00-დან 22:00-მდე',
      address: 'მისამართი',
      address_content: '16 კმ აღმაშენებლის გამზირი, <br> 0131 თბილისი, საქართველო',
      subscribed_successfully: 'გამოწერილია',
      unsubscribed_successfully: 'გაუქმებულია',
      bookmarked_successfully: 'სიახლე წარმატებით შეინახა',
      subscribe_list_stores: 'გამოწერილი მაღაზიები',
      see_the_list_below: 'იხილეთ მაღაზიების სია  :',
      subscribeText: 'გამოიწერე ჩვენი საიტი და მიიღე ინფორმაცია შემოთავაზებების და სიახლეების შესახებ.',
      enter_your_email: 'შეიყვანეთ თქვენი ელ-ფოსტა'
    }
  }
}

export default messages
